import { render, staticRenderFns } from "./dangerJournalAppr.vue?vue&type=template&id=2b55b6e4"
import script from "./dangerJournalAppr.vue?vue&type=script&lang=js"
export * from "./dangerJournalAppr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b55b6e4')) {
      api.createRecord('2b55b6e4', component.options)
    } else {
      api.reload('2b55b6e4', component.options)
    }
    module.hot.accept("./dangerJournalAppr.vue?vue&type=template&id=2b55b6e4", function () {
      api.rerender('2b55b6e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/appr/chm/dangerJournalAppr.vue"
export default component.exports